module.exports = __webpack_public_path__ + "static/blessed-trinity-535509eb2b6c5c2be18cd719766423f8.jpg";